import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import Icon from '../Icon';
import './styles.css';

const BusinessPlanModeDescription = ({ game }) =>
	<div className="business-plan-mode-description">
		<FormattedHTMLMessage id="business-plan-title" />
		{
			game.businessPlan.readOnly ?
				(
					<div className="business-plan-subtitle-read-only">
						<FormattedHTMLMessage id={'business-plan-subtitle-read-only'} />
						<br/>
						<FormattedHTMLMessage id={'business-plan-subtitle-read-only-2'} />
						{game.businessPlan.submission}
						<Icon icon="reviewEye" />
					</div>
				)
				: (
					<FormattedHTMLMessage id={'business-plan-subtitle'} />
				)
		}
	</div>
;

export default BusinessPlanModeDescription;
